import React, { useState, useEffect, useRef } from "react";
import Logo from "../../assests/icon/logo.png";
import Call from "../../assests/icon/call.png";
import Date from "../../assests/icon/date.png";
import Location from "../../assests/icon/location.png";
import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaLinkedin,
} from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";

const ResponsiveHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const handleBookNow = () => {
    window.open("https://shellharbourroaddentists.portal.dental", "_blank");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <div>
      {/* Mobile Header - ONLY Shown on Extra Small Screens */}
      <div className="lg:hidden w-full bg-[#F0F5F8] py-4 px-4 fixed top-0 left-0 right-0 z-[9998] shadow-sm">
        <div className="flex justify-between items-center">
          <img
            src={Logo}
            alt="Logo"
            className="w-[150px] h-[36px] object-contain"
          />
          <button
            ref={buttonRef}
            onClick={toggleMenu}
            className="flex justify-center items-center w-10 h-10"
          >
            {isMenuOpen ? (
              <span className="text-4xl text-[#1A76D1]">×</span>
            ) : (
              <div className="flex flex-col justify-center items-center">
                <span className="block w-6 h-0.5 bg-[#1A76D1] mb-1.5"></span>
                <span className="block w-6 h-0.5 bg-[#1A76D1] mb-1.5"></span>
                <span className="block w-6 h-0.5 bg-[#1A76D1]"></span>
              </div>
            )}
          </button>
        </div>
      </div>

      <div className="lg:hidden w-full bg-white py-2 px-4 fixed top-[65px] left-0 right-0 z-[9997] shadow-sm">
        <div className="flex flex-col gap-2 text-[10px] sm:text-[12px]">
          {/* Row 1: Phone & Book Now */}
          <div className="flex items-center justify-between w-full">
            {/* Phone */}
            <div className="flex  items-center gap-2 flex-shrink-0">
              <img src={Call} alt="Call" className="w-[16px] h-[16px]" />
              <span className="text-[#1A76D1]">(02) 4216 9919</span>
            </div>

            {/* Book Now Button */}
            <div className="mt-2">
              <button
                onClick={handleBookNow}
                className="px-4 py-2 bg-[#00D3BE] rounded-md text-white text-[10px] sm:text-[12px] font-[500] whitespace-nowrap"
              >
                Book Now with Dr. Angadi
              </button>
            </div>
          </div>

          {/* Row 2: Business Hours & Location */}
          <div className="flex items-center justify-between w-full">
            {/* Business Hours */}
            <div className="flex items-center gap-2 flex-shrink-0">
              <img src={Date} alt="Date" className="w-[16px] h-[16px]" />
              <div className="text-black">
                <div>
                  Mon-Fri{" "}
                  <span className="text-gray-500">8.30 AM - 5.30 PM</span>
                </div>
                <div>
                  Saturday <span className="text-gray-500">8 AM - 12 PM</span>
                </div>
              </div>
            </div>

            {/* Location (Forcing Address to Two Lines) */}
            <div className="flex items-start gap-2 flex-shrink-0">
              <img
                src={Location}
                alt="Location"
                className="w-[16px] h-[16px] mt-1"
              />
              <div className="text-black leading-tight">
                <div>237 Shellharbour Road,</div>
                <div>Barrack Heights, 2528</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add padding to prevent content from getting hidden under the header */}
      <div className="lg:hidden w-full h-[80px]"></div>

      {/* Mobile Menu Overlay - Full Screen */}
      {isMenuOpen && (
        <div
          ref={menuRef}
          className="fixed top-[75px] right-2 w-[250px] max-w-[90%] h-[450px] bg-slate-200 z-[9999] md:block lg:hidden overflow-hidden"
        >
          <div className="w-full h-full overflow-y-auto px-4 py-6">
            {/* Mobile Header Content */}
            <div className="flex flex-col h-full">
              {/* Logo */}
              <div className="flex justify-center mb-4">
                <img
                  src={Logo}
                  alt="Logo"
                  className="w-[140px] h-[35px] object-contain"
                />
              </div>

              {/* Navigation Links */}
              <div className="space-y-4 text-center text-[12px] flex-grow">
                <a
                  href=""
                  className="block text-[#1A76D1] font-jakartaSans font-[700] py-1"
                >
                  Home
                </a>
                <a
                  href=""
                  className="block text-[#1A76D1] font-jakartaSans font-[500] py-1"
                >
                  About Us
                </a>
                <a
                  href=""
                  className="block text-[#1A76D1] font-jakartaSans font-[500] py-1"
                >
                  Our Team
                </a>
                <a
                  href=""
                  className="block text-[#1A76D1] font-jakartaSans font-[500] py-1"
                >
                  Services
                </a>
                <a
                  href=""
                  className="block text-[#1A76D1] font-jakartaSans font-[500] py-1"
                >
                  Technology
                </a>
                <a
                  href=""
                  className="block text-[#1A76D1] font-jakartaSans font-[500] py-1"
                >
                  Payment Options
                </a>
                <a
                  href=""
                  className="block text-[#1A76D1] font-jakartaSans font-[500] py-1"
                >
                  More Info
                </a>
              </div>

              {/* Social Icons */}
              <div className="flex justify-center gap-4 mt-4">
                <FaInstagramSquare color="#1A76D1" size={20} />
                <FaSquareXTwitter color="#1A76D1" size={20} />
                <FaFacebookSquare color="#1A76D1" size={20} />
                <FaLinkedin color="#1A76D1" size={20} />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="hidden lg:block">
        <div className="container">
          {/* Desktop Header */}
          <div className="flex justify-between items-center">
            <div className="w-[35%]">
              <img src={Logo} alt="Logo" className="w-[320px] h-[78px] my-1" />
            </div>
            <div className="flex justify-end items-center gap-5 w-[65%]">
              <div className="my-5">
                <div className="flex justify-between items-center">
                  <div className="flex justify-between items-center font-[500]">
                    <img
                      src={Call}
                      alt="Call"
                      className="w-[36px] h-[36px] mx-2"
                    />
                    <div>(02) 4216 9919</div>
                  </div>
                  <div className="flex justify-between items-center font-[500]">
                    <img
                      src={Date}
                      alt="Date"
                      className="w-[36px] h-[36px] mx-2"
                    />
                    <div>
                      Mon-Fri
                      <br />
                      <span className="font-[400] text-[12px]">
                        8.30 AM - 5.30 PM
                      </span>
                    </div>
                  </div>
                  <div className="font-[500]">
                    Saturday
                    <br />
                    <span className="font-[400] text-[12px]">8 AM -12 PM</span>
                  </div>
                </div>
                <div className="flex justify-start items-center">
                  <img
                    src={Location}
                    alt="Location"
                    className="w-[30px] h-[36px] mx-2"
                  />
                  <div className="font-[500] text-[18px]">
                    237 Shellharbour Road, Barrack Heights, 2528
                  </div>
                </div>
              </div>
              <div>
                <button
                  onClick={handleBookNow}
                  className="px-3 py-2 bg-[#00D3BE] rounded-[6px] text-white text-[20px] font-[400]"
                >
                  Book Now with
                  <br /> Dr.Angadi
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#F0F5F8]">
          <div className="flex justify-between items-center container">
            <div className="flex justify-start items-center w-[70%]">
              <a
                href=""
                className="text-[#1A76D1] font-jakartaSans text-[16px] font-[700] border-b-2 border-[#197BDF]"
              >
                Home
              </a>
              <a
                href=""
                className="text-[#1A76D1] font-jakartaSans text-[16px] font-[500] mx-5"
              >
                About Us
              </a>
              <a
                href=""
                className="text-[#1A76D1] font-jakartaSans text-[16px] font-[500]"
              >
                Our Team
              </a>
              <a
                href=""
                className="text-[#1A76D1] font-jakartaSans text-[16px] font-[500] mx-5"
              >
                Services
              </a>
              <a
                href=""
                className="text-[#1A76D1] font-jakartaSans text-[16px] font-[500]"
              >
                Technology
              </a>
              <a
                href=""
                className="text-[#1A76D1] font-jakartaSans text-[16px] font-[500] mx-5"
              >
                Payment Options
              </a>
              <a
                href=""
                className="text-[#1A76D1] font-jakartaSans text-[16px] font-[500]"
              >
                More Info
              </a>
            </div>
            <div className="w-[30%]">
              <div className="flex justify-end items-center gap-4">
                <FaInstagramSquare color="#1A76D1" size={28} />
                <FaSquareXTwitter color="#1A76D1" size={28} />
                <FaFacebookSquare color="#1A76D1" size={28} />
                <FaLinkedin color="#1A76D1" size={28} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponsiveHeader;
